export default {
	header: {
		self: {},
		items: [],
	},
	aside: {
		self: {},
		items: [
			{
				title: "Dashboard",
				root: true,
				icon: "fas fa-tachometer-alt",
				page: "dashboard",
				bullet: "dot",
			},
			{
				title: "Usuários",
				root: true,
				icon: "fas fa-users",
				page: "usuario",
				bullet: "dot",
			},
			{
				title: "Locais",
				root: true,
				icon: "fas fa-building",
				page: "local",
				bullet: "dot",
			},
			{
				title: "Exercícios",
				root: true,
				icon: "fas fa-dumbbell",
				page: "exercicio",
				bullet: "dot",
			},
			{
				title: "Programas",
				root: true,
				icon: "fas fa-clipboard-list",
				page: "programa",
				bullet: "dot",
			},
			{
				title: "Notificações",
				root: true,
				icon: "fas fa-paper-plane",
				page: "notificacao",
				bullet: "dot",
			},
			{
				title: "Relatórios",
				root: true,
				bullet: "dot",
				icon: "fas fa-chart-pie",
				submenu: [
					{
						title: "Novos usuários",
						bullet: "dot",
						page: "relatorio/01",
					},
					{
						title: "Agendamentos",
						bullet: "dot",
						page: "relatorio/02",
					},
					{
						title: "Assinaturas",
						bullet: "dot",
						page: "relatorio/03",
					},
				],
			},
			{
				title: "Acessos",
				root: true,
				bullet: "dot",
				icon: "fas fa-user-shield",
				submenu: [
					{
						title: "Admins",
						bullet: "dot",
						page: "admin",
					},
					{
						title: "Grupo de admins",
						bullet: "dot",
						page: "grupo",
					},
				],
			},
		],
	},
};
